import { useEffect, useState } from "react";
import Api from "../api/api";
import Loader from "../shared/loader";
import Pagination from "../shared/pagination";
import arrayUtilities from "../../utilities/arrayUtilities";
import stringHelpers from "../../utilities/stringHelpers";
import { toDateTimeString } from "../../utilities/dateUtilities";
import { Modal } from "react-bootstrap";
import Enums from "../../utilities/enum";
import { Link } from 'react-router-dom';
import { SearchBarWithDebounce } from "../shared/searchBarWithDebounce";
import { FiltersModalTrigger } from "../shared/filtersModalTrigger";
import { AppliedFilterDisplay } from "../shared/appliedFilterDisplay";
import { EmailsFiltersModal } from "./filters-modals/EmailsFiltersModal";
import { EmailsScheduleModal } from "../reports/schedule-modals/emailsScheduleModal";

export const EmailsRawData = ({ organisationId, token }) => {
    const [emailModal, setEmailModal] = useState(null)
    const [emailsData, setEmailsData] = useState(null);
    const [emailsSearch, setEmailsSearch] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [datePreset, setDatePreset] = useState(null);
    const [status, setStatus] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);

    const [showScheduleExportModal, setShowScheduleExportModal] = useState(false);

    const scheduleDateParameters = datePreset !== null
        ? { reportDatePreset: datePreset }
        : { from: fromDate, to: toDate }

    const scheduleInitialParameters = {
        ...scheduleDateParameters,
        emailStatus: status,
    }

    const closeScheduleExportModal = () => setShowScheduleExportModal(false)

    const getEmailsData = (searchQuery, from, to, pageNumber, status) => {
        setIsLoading(true);
        Api.getEmailsRawData(
            data => {
                setEmailsData(data);
                setIsLoading(false);
            },
            () => {
                setEmailsData(null);
                setIsLoading(false);
            },
            searchQuery,
            from, to, status, pageNumber, organisationId, token
        )
    }

    const changepageNumber = (num) => {
        getEmailsData(emailsSearch, fromDate, toDate, num, status)
        setPageNumber(num);
    };

    useEffect(() => getEmailsData("", null, null, 0, null), [])

    const clearFilters = () => {
        setFromDate(null);
        setToDate(null);
        setDatePreset(null);
        setStatus(null)
        setAppliedFilters(null);
        setShowFilterPills(false);
        setPageNumber(0);
        getEmailsData(emailsSearch, null, null, 0, null);
    }

    const clearFilterByLabel = (label) => {
        switch (label) {
            case "From":
                setFromDate(null)
                getEmailsData(emailsSearch, null, toDate, 0, status)
                break
            case "To":
                setToDate(null)
                getEmailsData(emailsSearch, fromDate, null, 0, status)
                break
            case "Date Range":
                setFromDate(null)
                setToDate(null)
                setDatePreset(null)
                getEmailsData(emailsSearch, null, null, 0, status)
                break
            case "Status":
                setStatus(null)
                getEmailsData(emailsSearch, fromDate, toDate, 0, null)
            break
            default:
                break
        }
        setPageNumber(0)
    }

    return <div className="container-fluid">
        <div className="row">
            <div className="col-12">
                <div className="card mb-3">
                    <div className="card-header">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-1 d-flex align-items-center pr-0">
                                <h5 className="mb-0">Emails</h5>
                            </div>
                            <div className="col-auto d-flex align-items-center ml-auto text-right pl-0">
                                <div className='mr-2'>
                                    <SearchBarWithDebounce
                                        onSearchQueryChange={ query => {
                                            setEmailsSearch(query)
                                            getEmailsData(query, fromDate, toDate, 0, status)
                                            setPageNumber(0)
                                        } }
                                    />
                                </div>
                                <div className='mr-2'>
                                    <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                </div>
                                <button
                                    className="btn btn-primary btn-sm mr-1 ml-1 nowrap"
                                    onClick={ () => getEmailsData(emailsSearch, fromDate, toDate, pageNumber, status) }>
                                    <i className="fas fa-redo"></i> Refresh
                                </button>
                                <button
                                    className="btn btn-secondary btn-sm mr-1 ml-1 nowrap"
                                    onClick={ () => setShowScheduleExportModal(true) }>
                                    <i className="far fa-clock"></i> Schedule Report
                                </button>
                            </div>
                        </div>
                    </div>
                    {
                        showFilterPills && appliedFilters &&
                        <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                            {
                                Object.entries(appliedFilters).map(
                                    ([label, value]) => !stringHelpers.isNullOrEmpty(value)
                                        && <div className="mr-2" key={ label }>
                                            <AppliedFilterDisplay
                                                label={ label }
                                                onTextClick={ () => setShowFiltersModal(true) }
                                                onCloseClick={ closedLabel => {
                                                    clearFilterByLabel(closedLabel)
                                                    setAppliedFilters(prevState => {
                                                        const updatedFilters = { ...prevState }
                                                        if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
                                                            updatedFilters.From = null
                                                            updatedFilters.To = null
                                                            updatedFilters["Date Range"] = null
                                                        } else {
                                                            updatedFilters[closedLabel] = null
                                                        }
                                                        const hasRemainingFilters = Object.values(updatedFilters).some(value => !stringHelpers.isNullOrEmpty(value))
                                                        return hasRemainingFilters ? updatedFilters : null
                                                    })
                                                } }
                                                value={ value }
                                            />
                                        </div>
                                )
                            }
                            { appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={ () => clearFilters() }>Clear all filters</button> }
                        </div>
                    }
                    { isLoading
                        ? <Loader />
                        : <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                            <thead className="bg-200 text-900">
                                <tr>
                                    <th>Sent</th>
                                    <th>PCN Reference</th>
                                    <th>Subject</th>
                                    <th>Recipient</th>
                                    <th>Status</th>
                                    <th>Last Updated</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>

                            <tbody>
                                {
                                    !arrayUtilities.isNullOrEmpty(emailsData?.items) && emailsData?.items.map(
                                        email => <tr className={ email.sendGridStatus === 3 ? "table-danger" : "" }>
                                                <td>{ toDateTimeString(email.timestamp) }</td>
                                                <td><Link to={ `/organisation/${ organisationId }/breach/${ email.breachId }` }><h6 className="m-0">{ email.pcnReferenceNumber }</h6></Link></td>
                                                <td>{ email.subject }</td>
                                                <td>{ email.recipients }</td>
                                                <td>{ Enums.SendGridStatus[email.sendGridStatus] }</td>
                                                <td>{ toDateTimeString(email.sendGridLastUpdated) }</td>
                                                <td className="text-right">
                                                    <button onClick={ () => {
                                                        setEmailModal(email)
                                                    } } className='btn btn-info btn-xs mr-3'><i className="fas fa-eye"></i> View</button>
                                                </td>
                                            </tr>
                                    )

                                }
                            </tbody>
                        </table>
                    }
                    <div className="d-flex justify-content-center row align-items-center pt-2">
                        <div className="col-auto align-items-center">
                            <Pagination totalResults={ emailsData?.totalCount } currentPage={ pageNumber } changePageNumber={ changepageNumber } />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        { emailModal !== null && <Modal show onHide={ () => setEmailModal(null) } size="lg">
            <Modal.Header>
                <Modal.Title>
                    { emailModal.subject }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="px-1">
                    <p><b>Date: </b>{ toDateTimeString(emailModal.timestamp) }</p>
                    <p><b>To: </b>{ emailModal.recipients }</p>
                    <p><b>Status: </b>{ Enums.SendGridStatus[emailModal.sendGridStatus] } <i className="fas fa-exclamation-triangle text-danger"></i></p>
                    <p className='text-pre-wrap'>{ emailModal.content }</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-secondary mt-1" onClick={ () => setEmailModal(null) }>Close</button>
            </Modal.Footer>
        </Modal> }
        {
            showFiltersModal &&
            <EmailsFiltersModal
                showModal={ showFiltersModal }
                handleClose={ () => setShowFiltersModal(false) }
                handleConfirm={ (draftFilters) => {
                    setFromDate(draftFilters.fromDate)
                    setToDate(draftFilters.toDate)
                    setDatePreset(draftFilters.datePreset)
                    setStatus(draftFilters.status)
                    setAppliedFilters(draftFilters.appliedFilters)
                    setShowFilterPills(true)
                    setShowFiltersModal(false)
                    setPageNumber(0)
                    getEmailsData(emailsSearch, draftFilters.fromDate, draftFilters.toDate, 0, draftFilters.status)
                } }
                initialFromDate={ fromDate }
                initialToDate={ toDate }
                initialDatePreset={ datePreset }
                initialStatus={status}
                initialAppliedFilters={ appliedFilters }
                key="emails-raw-data-filters-modal"
            />
        }
        {
            showScheduleExportModal &&
            <EmailsScheduleModal
                organisationId={ organisationId }
                token={ token }
                initialParameters={ scheduleInitialParameters }
                onCancel={ closeScheduleExportModal }
                onSaved={ closeScheduleExportModal }
            />
        }
    </div>
}